module.exports = __webpack_public_path__ + "static/media/Portfolio.1844cfa2.svg";